import { TypographyRhythm, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import { tValueJapan, tValueSizing } from './tValues';

interface ProductSizingModalProps {
  readonly onSizeLinkClick: () => void;
}

const JapanSizeModal = ({
  onSizeLinkClick,
}: ProductSizingModalProps): JSX.Element => {
  const t = useTranslations();

  return (
    <>
      <TypographyRhythm>
        <TypographyV3 variant="h1">
          {t('pdp_horizon_sizing_modal_title')}
        </TypographyV3>

        <TypographyV3 variant="h6" weight="medium">
          {t.rich('japan_size_in_store', tValueJapan)}
        </TypographyV3>
      </TypographyRhythm>
      <TypographyRhythm>
        <TypographyV3 variant="h6" weight="medium">
          {t('pdp_horizon_sizing_modal_expect')}
        </TypographyV3>

        <TypographyV3
          variant="body-small"
          color="unset"
          className="text-burntOrange"
        >
          {t('pdp_horizon_sizing_modal_step_1_title')}
        </TypographyV3>

        <TypographyV3>
          {t('pdp_horizon_sizing_modal_step_1_description')}
        </TypographyV3>

        <TypographyV3
          variant="body-small"
          color="unset"
          className="text-burntOrange"
        >
          {t('pdp_horizon_sizing_modal_step_2_title')}
        </TypographyV3>

        <TypographyV3>
          {t('pdp_horizon_sizing_modal_step_2_description')}
        </TypographyV3>

        <TypographyV3
          variant="body-small"
          color="unset"
          className="text-burntOrange"
        >
          {t('pdp_horizon_sizing_modal_step_3_title')}
        </TypographyV3>

        <TypographyV3>
          {t('pdp_horizon_sizing_modal_step_3_description')}
        </TypographyV3>

        <TypographyV3>
          {t.rich(
            'pdp_horizon_sizing_modal_learn_more_watch',
            tValueSizing(onSizeLinkClick),
          )}
        </TypographyV3>
      </TypographyRhythm>
    </>
  );
};
export default JapanSizeModal;
